export type PegaStartingFields = {
  Product?: string | null;
  AccountID?: string | null;
  MultiAsset?: boolean | null;
  TenantID?: string | null;
  Context?: string | null;
  OnboardingRegion?: string | null;
  Domain?: string | null;
  Platform?: string | null;
  CustomerType?: string | null;
  IsFromPlatform?: boolean | null;
  Channel?: string | null;
  CaseID?: string | null;
};

export function buildQueryParams(fields?: PegaStartingFields): string {
  const params = new URLSearchParams();

  if (fields?.MultiAsset) {
    params.append('MultiAsset', fields.MultiAsset.toString());
  }
  if (fields?.Product) {
    params.append('Product', fields.Product);
  }
  if (fields?.AccountID) {
    params.append('AccountId', fields.AccountID.toString());
  }
  if (fields?.TenantID) {
    params.append('TenantID', fields.TenantID);
  }
  if (fields?.Context) {
    params.append('Context', fields.Context);
  }
  if (fields?.OnboardingRegion) {
    params.append('OnboardingRegion', fields.OnboardingRegion);
  }
  if (fields?.Domain) {
    params.append('Domain', fields.Domain);
  }
  if (fields?.Platform) {
    params.append('Platform', fields.Platform);
  }
  if (fields?.CustomerType) {
    params.append('CustomerType', fields.CustomerType);
  }
  if (fields?.IsFromPlatform) {
    params.append('IsFromPlatform', fields.IsFromPlatform.toString());
  }
  if (fields?.Channel) {
    params.append('Channel', fields.Channel);
  }
  if (fields?.CaseID) {
    params.append('CaseID', fields.CaseID);
  }

  return params.toString();
}
